import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined'
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined'
import { ACTIVITY_REPORT_MAP_COLORS } from './constants'

const LEGEND_DOT_CLASS_BY_COLOR = {
  red: 'activity-map-mobile-legend-dot--red',
  blue: 'activity-map-mobile-legend-dot--blue',
  green: 'activity-map-mobile-legend-dot--green',
  geofence: 'activity-map-mobile-legend-dot--geofence-none'
}

export default function ActivityReportMapLegend({ items = [], isMobileLayout = false }) {
  if (isMobileLayout) {
    return (
      <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap className="activity-map-mobile-legend">
        {items.map((item) => (
          <Box key={item.key} component="span" className="activity-map-mobile-legend-pill">
            <Box
              component="span"
              className={`activity-map-mobile-legend-dot ${
                item.dotClassName || LEGEND_DOT_CLASS_BY_COLOR[item.color] || ''
              }`}
            />
            {item.label}
          </Box>
        ))}
      </Stack>
    )
  }

  return (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
      {items.map((item) => (
        <Stack key={item.key} direction="row" spacing={0.75} alignItems="center">
          {item.color === 'geofence' ? (
            <RadioButtonCheckedOutlinedIcon
              sx={{ color: ACTIVITY_REPORT_MAP_COLORS.geofenceLegend, fontSize: 18 }}
            />
          ) : (
            <RoomOutlinedIcon sx={{ color: item.pinColor || item.color, fontSize: 18 }} />
          )}
          <Typography sx={{ color: ACTIVITY_REPORT_MAP_COLORS.legendText, fontSize: 13, fontWeight: 600 }}>
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}
